<fury-page>
  <fury-title class="title">
    <span [@fadeInRight]>Add Claim Question</span>
  </fury-title>
</fury-page>
<div fxLayout="column" fxLayoutAlign="start center">
  <div [@fadeInUp] class="card">
    <form [formGroup]="claimQuestionForm">
      <div class="content" fxLayout="column" fxLayoutGap="8px">
        <mat-form-field appearance="outline">
          <mat-label>Question</mat-label>
          <input matInput placeholder="Question" formControlName="question" />
          <mat-error
            *ngIf="claimQuestionForm.get('question').hasError('required')"
          >
            This is a required field.
          </mat-error>
          <mat-error
            *ngIf="claimQuestionForm.get('question').hasError('minlength')"
          >
            Minimum length should be 2.
          </mat-error>
        </mat-form-field>
  
        <div formArrayName="answers">
          <div *ngFor="let item of answersControl.controls; let i = index">
            <div [formGroupName]="i" class="coverprt">
              <div class="answerprt">
                <mat-form-field appearance="outline">
                  <mat-label>Answer</mat-label>
                  <input
                    matInput
                    placeholder="Type Answer"
                    formControlName="answer"
                  />
                  <mat-error *ngIf="item.get('answer').hasError('required')">
                    This is a required field.
                  </mat-error>
                  <mat-error *ngIf="item.get('answer').hasError('minlength')">
                    Minimum length should be 2.
                  </mat-error>
                </mat-form-field>
    
                <mat-checkbox formControlName="isCovered" class="checkprt">Is Covered</mat-checkbox>
              </div>
              
  
              <span
                (click)="removeAnswer(i)"
                class="remove"
                *ngIf="answersControl.controls.length > 1"
                ><mat-icon>clear</mat-icon></span
              >
            </div>
          </div>
          <button
            type="button"
            mat-raised-button
            (click)="addAnswer()"
            [disabled]="
              claimQuestionForm?.controls?.answers?.status === 'INVALID'
            "
          >
          <mat-icon>add_circle_outline</mat-icon> Add Answer
          </button>
        </div>
      </div>
      

      <div
        class="actions"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="8px"
      >
        <button
          mat-button
          type="button"
          class="sub-button"
          (click)="addClaimQuestion()"
        >
          <span>Add</span>
        </button>
        <button
          mat-button
          type="button"
          class="can-button"
          (click)="this.location.back()"
        >
          <span>Cancel</span>
        </button>
      </div>
    </form>
  </div>
</div>
